<template>
  <div>
    <editor
      :api-key="tinyApiKey"
      v-model="assinatura.html"
      :init="configuracao"
      :disabled="desabilitarEditorAssinatura()"
      @input="executarRequisicaoCorreta()"/>
    <v-card-text class="pl-0 pr-0">
      <v-row no-gutters>
        <v-col md="7" lg="7"></v-col>
        <v-col md="3" lg="3" class="text-end">
          <v-btn
            class="text-capitalize"
            style="color: #4c2779"
            depressed
            tile
            @click="abrirPopUpDeAgendamento()"
            :disabled="bloquearAcoesDaAssinatura"
            text
          >Agendar</v-btn>
          <c-agendamento
            @fecharDialog="dialog = false"
            :dialog="dialog"
            :temAgendamento="assinaturaDeEmail.temAgendamento"
            :idDoAgendamento="assinaturaDeEmail.idDoAgendamento"
            @atualizarDadosDoAgendamento ="(status, id) => {
              assinaturaDeEmail.temAgendamento = true;
              assinaturaDeEmail.idDoAgendamento = id;
            }"
          ></c-agendamento>
        </v-col>
        <v-col md="2" lg="2" class="text-end">
          <v-btn
            class="text-capitalize"
            style="color: #4c2779"
            depressed
            :loading="carregando"
            tile
            text
            :disabled="bloquearAcoesDaAssinatura"
            @click="aplicarAssinaturaDeEmail()"
          >Aplicar</v-btn>
        </v-col>
      </v-row>
    </v-card-text>
    <c-dialog-excluir
      @apagarRevendedor="() => {
      dialog = true;
      dialogDeConfirmacao = false;
    }"
      @fecharDialog="dialogDeConfirmacao = false"
      :dialogModalExcluir="dialogDeConfirmacao"
      txtModal="Você já possui um agendamento cadastrado,<br/> deseja atualiza-lo?"
    ></c-dialog-excluir>
  </div>
</template>
<script>
import Editor from "@tinymce/tinymce-vue";
import { mapState, mapActions } from "vuex";
import {
  headersUploadDeArquivo,
  headersPadrao
} from "../../mixins/HeadersMixin.js";
import AssinaturasMixin from "../../mixins/AssinaturasMixin.js";
import { enviar, editar } from "../../mixins/RequisicaoMixin.js";
import { 
  tagEmHtml
} from "../../mixins/tags/gerenciarTags.js";
import { bus } from "../../main";
import Agendamento from "./Agendamento";
import DialogExcluir from "../usuarios/DialogExcluir";
import { debounce } from 'lodash';

export default {
  components: {
    editor: Editor,
    "c-agendamento": Agendamento,
    "c-dialog-excluir": DialogExcluir
  },
  mixins: [AssinaturasMixin],
  data() {
    var vm = this;
    return {
      chip3: true,
      tinymce: null,
      tinyApiKey: process.env.VUE_APP_API_KEY_ENV,
      assinatura: {
        html: ''        
      },
      url: process.env.VUE_APP_API_BACKEND,
      dataAgendamento: null,
      configuracao: {
        font_formats: 'Andale Mono=andale mono,times; Arial=arial,helvetica,  sans-serif; Arial Black=arial black,avant garde; Book Antiqua=book antiqua, palatino; Comic Sans MS=comic sans ms,sans-serif; Courier New=courier new, courier; Georgia=georgia,palatino; Helvetica=helvetica; Impact=impact, chicago; Tahoma=tahoma,arial,helvetica,sans-serif;  Terminal=terminal,monaco; Times New Roman=times new roman,times; Trebuchet   MS=trebuchet ms,geneva; Verdana=verdana,geneva;',
        formatars: {
          customformat: { block: 'p', styles: { color: '#00ff00', fontSize: '20px' }, classes: 'example1'}
        },
        icons_url: "",
        br_in_pre: true,
        nowrap: true,
        entity_encoding: "raw",
        content_css:
          "https://cdn.jsdelivr.net/npm/vuetify@2.x/dist/vuetify.min.css",
        inline_styles: true,
        height: 400,
        selector: "textarea",
        language: "pt_BR",
        content_style: `
        .icone-fechar-tag:hover{cursor: pointer}
        .cor-da-tag{
          background-color: #1867c0!important; 
          margin: 0px; 
          padding: 0!important; 
          border-color: #4c2779!important; 
          border-style: solid!important;
          height: 24px!important;}
        td{
          border: 1px dotted #ced4d9;
        }
        th{
          border: 1px dotted #ced4d9;
        }
        .texto-da-tag{
          color: #4c2779; 
          font-size: 12px!important;}
       *{margin: 0.3em}
        p, h1, h2, h3, h4, h5, h6, span, strong, img, a, em {margin:2px 0px; padding: 0px!important}, 
        td: {margin: 0px!important, padding: 0px!important}`,
        file_picker_types: "image",
        image_caption: true,
        toolbar_mode: "floating",
        toolbar: [
          {
            name: "styles",
            items: ["fontselect", "fontsizeselect"]
          },
          {
            name: "formatting",
            items: ["bold", "italic", "underline", "forecolor"]
          },
          {
            name: "image",
            items: ["image"]
          },
          {
            name: "alignment",
            items: ["alignleft", "aligncenter", "alignright", "alignjustify"]
          },
          {
            name: "list",
            items: ["numlist", "bullist"]
          },
          {
            name: "link",
            items: ["link"]
          }
        ],
        plugins: ["table", "lists", "image", "link"],
        menubar: " format table custom",
        setup: function(editor) {
          editor.ui.registry.addNestedMenuItem("modeloAssinatura", {
            text: "Exemplos",
            getSubmenuItems: function() {
              return vm.retornaItensModelos;
            }
          });
        },
        images_upload_url: process.env.VUE_APP_API_BACKEND,
        automatic_uploads: true,
        table_default_styles: {
          border: "1px",
          width: "100%",
          "border-color": "#ced4d9",
          "border-style": "dotted"
        },

        images_upload_handler: async function(blobInfo, success, failure) {
          let data = new FormData();
          data.append("arquivo", blobInfo.blob(), blobInfo.filename());
          const idCliente = JSON.parse(localStorage.getItem("usuarioLogado")).cliente;
          await enviar(
            `${process.env.VUE_APP_API_BACKEND}api/v1/multisign/clientes/${idCliente}/imagens`,
            headersUploadDeArquivo(),
            data
          )
            .then(resposta => {
              success(resposta.url);
            })
            .catch(err => {
              failure("HTTP Error: " + err.message);
            });
        },
        init_instance_callback: editor => {
          this.tinymce = editor;
          editor.on("keydown", e  => {
            const conteudoDaAssinatura = editor.getContent();
            this.apagarTagComBackspaceOuDelete(e, conteudoDaAssinatura);
          });
        }
      },
      ListaDeTagsNoModeloDeAssinatura: [],
      modeloDeAssinatura: {
        id: null
      },
      tags: [
        "email",
        "nome",
        "cargo",
        "departamento",
        "localidade",
        "telefone",
        "celular",
        "nomeDoAndar",
        "secaoDoAndar",
        "codigoDoFuncionario"
      ],
      carregando: false,
      dialog: false,
      dialogDeConfirmacao: false
    };
  },
  props: {
    assinaturaDeEmail: {
      type: Object
    }
  },
  computed: {
    ...mapState(["tagsDaAssinatura", 
    "tipoDaTag", 
    "aplicarAssinatura", 
    "idDoTemplate", 
    "atualizarAssinatura",
    "editorAssinaturaEstaAtivo"]),

    bloquearAcoesDaAssinatura(){
      if(this.aplicarAssinatura.id == null || this.idDoTemplate == null) return true
      else return false
    }
  },
  methods: {
    ...mapActions([
      "filtrarTagDeAssinatura", 
      "atualizarConteudoAssinatura"]),

    filtrarTag(tag) {
      return this.filtrarTagDeAssinatura(tag);
    },

    desabilitarEditorAssinatura() {
      if (this.aplicarAssinatura.id == null) {
        return true;
      }
      return this.editorAssinaturaEstaAtivo;
    },

    atualizarTagsNoModeloDeAssinatura(listaDeTags){
      listaDeTags.map(tag => {
        const existeTag = this.ListaDeTagsNoModeloDeAssinatura.indexOf(tag);
        if(existeTag !== -1){
          this.ListaDeTagsNoModeloDeAssinatura.splice(existeTag, 1);
        }
      });
      return this.ListaDeTagsNoModeloDeAssinatura;
    },

    excluirTagNoModeloDeAssinatura(nomeDatag) {
      const textoDatag = nomeDatag.toUpperCase();
      if(textoDatag == "NOME"){
        this.assinatura.html = this.assinatura.html.replace(/NOME(?!_DO_ANDAR)/g, "")
        return this.assinatura.html;
      }
      this.assinatura.html = this.assinatura.html.replace(textoDatag, "");
      this.executarRequisicaoCorreta();
      return this.assinatura.html;
    },

    apagarTagComBackspaceOuDelete(event, conteudoTinymce) {
      /**
       * keyCode 8: tecla Backspace
       * keyCode 46: tecla Delete
       */
      if (event.keyCode === 8 || event.keyCode === 46) {
        const listaDetags = [];
        this.ListaDeTagsNoModeloDeAssinatura.map(tag => {
          const formatarTag = tag.toUpperCase();
          const existeTag = conteudoTinymce.search(formatarTag);
          if(existeTag === -1){
            listaDetags.push(tag);
            this.filtrarTag({
              nome: tag,
              status: false
            });
          }
        });
        this.atualizarTagsNoModeloDeAssinatura(listaDetags);
        this.executarRequisicaoCorreta();
        this.retirarMargemDasTags();
      }
    },

    repeticaoDeTags(){
      const repeticao = {
        nome: (conteudoDaAssinatura) => {
          const regex = "NOME(?!_DO_ANDAR)";
          const replaceNome = new RegExp(regex);
          const searchNome = new RegExp(regex, "g");
          const criarExpressaoRegular = {
            "replace": replaceNome,
            "search": searchNome
          }
          const existeTagRepetida = this.verificaRepeticaoDasTags(conteudoDaAssinatura, criarExpressaoRegular);
          if(existeTagRepetida !== -1) this.mostrarMensagemDeRepeticaoDaTag(); 
          return existeTagRepetida;
        }, 
        nome_do_andar: (conteudoDaAssinatura) => {
          const regexNomeDoAndar = "NOME_(?=DO_ANDAR)"
          const replaceNomeDoAndar =  new RegExp(regexNomeDoAndar);
          const searchNomeDoAndar = new RegExp(regexNomeDoAndar, "g");
          const repeticaoDeTags = {
            "replace": replaceNomeDoAndar, 
            "search": searchNomeDoAndar
          }
          const existeTagRepetida = this.verificaRepeticaoDasTags(conteudoDaAssinatura, repeticaoDeTags);
          if(existeTagRepetida !== -1) this.mostrarMensagemDeRepeticaoDaTag();
          return existeTagRepetida;
        }, 
        outrasTags: (conteudoDaAssinatura, tagFormatada) =>{
          const conteudoModificado = conteudoDaAssinatura.replace(tagFormatada, "null");
          const existeTag = conteudoModificado.indexOf(tagFormatada);
          if(existeTag !== -1) this.mostrarMensagemDeRepeticaoDaTag();
          return existeTag;
        },
      }
      return repeticao;
    },

    /**Função para verificar a existencia das tags NOME, NOMEDOANDAR  */
    verificaRepeticaoDasTags(conteudoDaAssinatura, regex){
      const novoConteudo = conteudoDaAssinatura.replace(regex.replace, "null");
      const existeTagRepetida = novoConteudo.search(regex.search);
      return existeTagRepetida;
    },
    mostrarMensagemDeRepeticaoDaTag(){
      this.$store.commit("erro", `A assinatura não pode conter tags repetidas`);
      return false;
    },
    gerenciarTagsRepetidas(){
      const conteudoDaAssinatura = this.assinatura.html;
      const verificarTagsRepetidas = this.repeticaoDeTags();
      this.ListaDeTagsNoModeloDeAssinatura.map(tag => {
        const tagFormatada = tag.toUpperCase();
        const existeTag = conteudoDaAssinatura.indexOf(tagFormatada);
        if(existeTag){
          if(tagFormatada === "NOME" || tagFormatada === "NOME_DO_ANDAR") {
            verificarTagsRepetidas[tag](conteudoDaAssinatura);
          }
          else {
            verificarTagsRepetidas["outrasTags"](conteudoDaAssinatura, tagFormatada);
          }
        }
      });
      return conteudoDaAssinatura;
    },
    retornaItensModelos() {
      let vm = this;
      let itensOficiais = [];
      for (let index = 0; index < vm.itensAssinaturas.length; index++) {
        const element = vm.itensAssinaturas[index];
        let elemento = {
          type: "menuitem",
          text: element.nome,
          onAction: function() {
            vm.assinatura.html = element.valor;
          }
        };
        itensOficiais.push(elemento);
      }
      return itensOficiais;
    },
    async aplicarAssinaturaDeEmail() {
      await this.retirarMargemDasTags();
      this.carregando = true;
      const url = "/api/v1/multisign";
      let dados = {};
      if(this.aplicarAssinatura.tipo == "organizacao"){
        dados = {
          idDoCliente: JSON.parse(localStorage.getItem("usuarioLogado")).cliente,
          idDaAssinatura: this.modeloDeAssinatura.id,
          path: this.aplicarAssinatura.path,
          html: this.modeloDeAssinatura.html
        };
      }else{
        dados = {
          idDoCliente: JSON.parse(localStorage.getItem("usuarioLogado")).cliente,
          idDaAssinatura: this.modeloDeAssinatura.id,
          idDoGrupo: this.aplicarAssinatura.id,
          html: this.modeloDeAssinatura.html
        }
      }
      await enviar(url, headersPadrao(), dados)
        .then(() => {
          this.$store.commit("sucesso", "Assinatura aplicada com sucesso.");
        })
        .catch(erro => {
          if(erro.request.status == 400){
            this.$store.commit("atualizarMensagemDeErro", JSON.parse(erro.request.response).debugMessage)
            this.$store.commit("erro");
          }else this.$store.commit("erro", "Erro ao aplicar o modelo de assinatura.")
        })
        .finally(() => (this.carregando = false));
    },
    async salvarAssinaturaDeEmail() {
      bus.$emit("salvandoAssinatura", false, "Salvando assinatura...")
      var url = `/api/v1/templates`;
      this.montarModeloDeAssinaturaParaEnvio();
      await enviar(url, headersPadrao(), this.modeloDeAssinatura)
        .then((resposta) => {
          this.modeloDeAssinatura.id = resposta.id;
          this.$store.commit("atualizarIdDoTemplate", this.modeloDeAssinatura.id)
          bus.$emit("salvandoAssinatura", false, "Assinatura salva");
        })
        .catch(erro => {
          bus.$emit("salvandoAssinatura", false, "Erro ao salvar a assinatura")
          if(erro.request.status == 400) {
            this.$store.commit("atualizarMensagemDeErro", JSON.parse(erro.request.response).debugMessage)
            this.$store.commit("erro");
          } else this.$store.commit("Erro ao salvar modelo de assinatura.")
        });
    },
    retirarMargemDasTags(){
      try {
        const contentTinymce = document.querySelector(".tox-edit-area__iframe").contentWindow;
        const tagHTML = contentTinymce.document.querySelectorAll("p");
        const listaDeTags = Array(...tagHTML);
        listaDeTags.map(tag => {
          tag.style.margin = "0px";
        });
      } catch (error) {
        throw new Error("A classe `.tox-edit-area__iframe` vinculada ao componente TinyMCE não existe");
      }
      return {};
    },
    montarModeloDeAssinaturaParaEnvio(){
      const formarAssinatura = {};
      this.gerenciarTagsRepetidas();
      this.retirarMargemDasTags();
      formarAssinatura.html = this.assinatura.html;
      formarAssinatura.idDoCliente = JSON.parse(localStorage.getItem("usuarioLogado")).cliente;
      this.ListaDeTagsNoModeloDeAssinatura.map(tag => {
        const tagFormatada = this.formatarTag(tag, 'enviar-tag');
        Object.defineProperty(formarAssinatura, tagFormatada, {
          enumerable: true,
            value: true, 
            writable: true,
        });
      });
      this.modeloDeAssinatura = formarAssinatura;
      if(this.aplicarAssinatura.tipo === "organizacao"){
        this.modeloDeAssinatura.organizacao = this.aplicarAssinatura.id;
        this.modeloDeAssinatura.pathDaUnidade = this.aplicarAssinatura.path;
        this.modeloDeAssinatura.nomeDaOrgOuGrupo = this.aplicarAssinatura.nome
        delete this.modeloDeAssinatura.id;  
      }else{
        this.modeloDeAssinatura.idDoGrupo = this.aplicarAssinatura.id;
        this.modeloDeAssinatura.nomeDaOrgOuGrupo = this.aplicarAssinatura.nome;
        delete this.modeloDeAssinatura.id;  
      }
    },
    /**
     * Função para formatação das tags nomeDoAndar, codigoDoFuncionario e secaoDoAdar
     * @param {String} tag tag a ser formatada
     * @param {String} tipo podem ser passados campo parametro `enviar-tag`
     */
    formatarTag(tag, tipo){
      const tipoDaTag = ["nome_do_andar", "codigo_do_funcionario", "secao_do_andar"];
      const tagsFormatadas = ["nomeDoAndar", "codigoDoFuncionario", "secaoDoAndar"];
      if(tipo == "enviar-tag"){
        const existeTag = tipoDaTag.indexOf(tag);
        if(existeTag !== -1) return tagsFormatadas[existeTag];
        return tag;
      }
      const existeTagFormatada = tagsFormatadas.indexOf(tag);
      if(existeTagFormatada !== -1) return tipoDaTag[existeTagFormatada];
      return tag;
    },
    async atualizarAssinaturaDeEmail() {
      var url = `/api/v1/templates/${this.modeloDeAssinatura.id}`;
      this.montarModeloDeAssinaturaParaEnvio();
      bus.$emit("salvandoAssinatura", false, "Salvando assinatura...");
      await editar(url, headersPadrao(), this.modeloDeAssinatura)
        .then(resposta => {

          this.modeloDeAssinatura.id = resposta.id;
          this.$store.commit("atualizarIdDoTemplate", this.modeloDeAssinatura.id)
          bus.$emit("salvandoAssinatura", false, "Assinatura salva");
        })
        .catch(erro => {
          bus.$emit("salvandoAssinatura", false, "Erro ao salvar a assinatura")
          if(erro.request.status == 400) {
            this.$store.commit("atualizarMensagemDeErro", JSON.parse(erro.request.response).debugMessage)
            this.$store.commit("erro");
          } else this.$store.commit("Erro ao atualizar modelo de assinatura.")
        });
    },
    abrirPopUpDeAgendamento() {
      if (this.assinaturaDeEmail.temAgendamento)
        this.dialogDeConfirmacao = true;
      else this.dialog = true;
    },
    executarRequisicaoCorreta: debounce(function() {
      if (this.modeloDeAssinatura.id != null && this.assinatura.html !== '') {
        return this.atualizarAssinaturaDeEmail();
      }
      if (this.assinatura.html !== '') {
        return this.salvarAssinaturaDeEmail();
      }
    }, 3000),
  },

  watch: {
    assinaturaDeEmail: function(assinatura){
      this.ListaDeTagsNoModeloDeAssinatura = [];
      this.modeloDeAssinatura.id = assinatura.id;
        for(let nome in assinatura){
          const nomeDaTag = this.formatarTag(nome, "receber-tag");
          if(assinatura[nome] === true){
            this.ListaDeTagsNoModeloDeAssinatura.push(nomeDaTag);
            this.filtrarTag({
              nome: nomeDaTag,
              status: true
            });
          }else{
            this.filtrarTag({
              nome: nomeDaTag,
              status: false,
            });
          }
        } 
        this.assinatura.html = assinatura.html;
        return this.assinatura.html
    },
    tipoDaTag(){
      const tagId = this.tipoDaTag.nome;
      if(this.tipoDaTag.valor){
        const nomeDaTag = tagEmHtml(this.tipoDaTag.nome);
        this.ListaDeTagsNoModeloDeAssinatura.push(tagId);
        this.tinymce.insertContent(nomeDaTag);
        this.assinatura.html = this.tinymce.getContent();
        return this.assinatura;
      }
      this.excluirTagNoModeloDeAssinatura(tagId);
      this.atualizarTagsNoModeloDeAssinatura([tagId]);
      return this.assinatura;
    }, 
    
    atualizarAssinatura: function(){
      this.atualizarConteudoAssinatura(this.assinatura.html)
      this.assinatura.html = '';
    }
  },

  destroyed() {
    this.assinatura.html = '';
  }
};

</script>
